<template>
  <div class="row">
    <div class="col-lg-12 col-xs-12">
      <button class="btn-blue-light pb-3  " @click="getData">
        <i class="fas fa-headset f20 mt-1" style="float:left "></i>
        ENTREVISTAS
      </button>
    </div>
  </div>
</template>

<script>
export default {
  methods:{
    getData(){}
  },
};
</script>

